import { StagedIcon } from "@packages/ds";
import { Link as LinkUnstyled } from "react-router-dom";
import styled, { css as styledCSS } from "styled-components";

import { IconControl as IconControlStyle } from "ds/Button";
import * as Dialog from "ds/Dialog";
import * as Dropdown from "ds/Dropdown";
import { semiBoldAlias } from "Libs/theme";
import { isEnvInactiveOrDeleting } from "Libs/utils";

export const Wrapper = styled(LinkUnstyled)`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  height: 32px;
  line-height: 32px;
  text-decoration: none;

  &:hover,
  &:focus {
    background-color: var(
      --link-color-primary-100-background-color,
      var(--color-primary-100)
    );
    border-radius: 4px;
    outline: none;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 16px;
  border-radius: var(
    --icon-wrapper-section-border-radius,
    var(--section-2px-border-radius, var(--2px))
  );
`;

export const IconRootWrapper = styled(IconWrapper)`
  background-color: var(--icon-java-background-color, var(--java));
  border-radius: var(
    --icon-wrapper-section-border-radius,
    var(--section-2px-border-radius, var(--2px))
  );
`;

export const IconParentWrapper = styled(IconWrapper)`
  background-color: var(
    --icon-color-primary-600-background-color,
    var(--color-primary-600)
  );
  border-radius: var(
    --icon-wrapper-section-border-radius,
    var(--section-2px-border-radius, var(--2px))
  );
`;

export const Title = styled.div<{
  isRootOrNonDevelopment?: boolean;
  status?: string;
}>`
  flex: 1;
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 20px;
  font-size: 15px;
  color: var(--section-ebony-color, var(--ebony));
  ${({ isRootOrNonDevelopment }) =>
    isRootOrNonDevelopment &&
    styledCSS`
      ${semiBoldAlias()};
  `}
  ${({ status }) =>
    isEnvInactiveOrDeleting(status) &&
    styledCSS`
      color: var(--section-granite-color,var(--granite));
  `}

  > span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const Info = styled.div`
  width: 100px;
  margin-right: 40px;
  ${semiBoldAlias()};
  font-size: 13px;
  color: var(--section-granite-color, var(--granite));
`;

export const Type = styled(Info)`
  text-transform: capitalize;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const CreatedAt = styled(Info)`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Deployment = styled(Info)`
  position: relative;
  width: 148px;
  margin-right: 6px;

  @media (max-width: 768px) {
    width: auto;
  }
`;

export const CommitSha = styled.div`
  display: block;
  margin: 8px 0 2px 0;
  font-size: 14px;
  line-height: 24px;
`;

export const DeployedAt = styled.div`
  ${semiBoldAlias()};
  font-size: 13px;
  line-height: 16px;
  color: var(--section-granite-color, var(--granite));
`;

export const Spacer = styled.div`
  display: block;
  width: 32px;
`;

export const WingsDialogRoot = styled(Dialog.Root)`
  position: absolute;
  left: -29px;
  margin: 0;
  top: 50%;
  transform: translateY(-50%);
`;

export const Content = styled(Dialog.Content)`
  margin-right: 120px;
`;

export const IconControl = styled(IconControlStyle)<{
  fill?: string;
  justifyContent?: string;
}>`
  display: flex;
  width: 100%;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : "space-between"};
  padding: 0 19px 0 16px;

  & > svg {
    color: ${props => (props.fill ? props.fill : "inherited")};
  }

  & > span {
    color: transparent;
  }
`;

export const WingsIconWrapper = styled.div`
  & svg {
    position: absolute;
    top: 0px;
    width: 24px;
    left: -29px;
  }

  &:hover svg > path {
    fill: var(--icon-color-primary-600-fill, var(--color-primary-600));
  }
`;

export const DropdownTrigger = styled(Dropdown.Trigger)`
  border-radius: 4px;
  color: var(--mode-text-primary-default);
  &:hover {
    color: var(--mode-text-neutral-inverse-strong);
    background-color: var(--mode-text-primary-default);
  }
`;

export const Staged = styled(StagedIcon)`
  margin-left: 8px;
`;

export const TooltipContent = styled.div`
  display: flex;
  margin-right: 6px;
`;
